import styled from '@emotion/styled';

export const ReviewSections = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const SummaryCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: 16,
  borderRadius: theme.radius[12],
  backgroundColor: theme.colors.background.canvas,
}));

export const SummaryHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,

  '& > *:last-child': {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const LogoImage = styled('img')({
  width: 48,
  height: 48,
  borderRadius: '50%',
  objectFit: 'cover',
  display: 'block',
  flexShrink: 0,
});

export const SummaryRows = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& > * + *': {
    borderTop: `1px solid ${theme.colors.border.default}`,
  },
}));

export const SummaryRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  padding: '8px 0',
  minHeight: 40,
  boxSizing: 'border-box',
});

export const RowLabel = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexShrink: 0,
  color: theme.colors.text.secondary,

  '& svg': {
    width: 16,
    height: 16,
    flexShrink: 0,
  },
}));

export const RowValue = styled('div')({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'right',
});

export const BadgeRow = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
});
